import React, { useState } from 'react';
import Header from '../sections/Header';
import Banner from '../sections/Banner';
import Footer from '../sections/Footer';
import Breadcrumbs from '../sections/Breadcrumbs';

const Maker: React.FC = () => {

  return (
  <>
    <Banner
      header={<Header />}
      breadcrumbs={<Breadcrumbs items={[
        { label: 'Home', href: '/' },
        { label: 'Initiatives', href: '/initiatives' },
        { label: 'AI Literacy Uplift & Alignment', href: '/initiative-one/ai-literacy-uplift-and-alignment' },
        { label: 'Maker' }
      ]} />}
      subheading="Initiative One"
              title="Maker AI Lab"
        subtitle="This is the Maker AI Lab page. More content coming soon."
      colorVariant="gradient"
      imageVariant="withImage"
      paddingVariant="default"
    />
    <div className="max-w-4xl mx-auto py-12 px-4 text-center">
      <h2 className="text-2xl font-bold mb-4">Coming Soon</h2>
              <p>Content for the Maker AI Lab will be available here soon.</p>
    </div>
    <Footer />
  </>
  );
};

export default Maker; 